// Utility function to convert VAPID public key to Uint8Array
import { WebPushRegistrationDto } from "./WebPushRegistrationDto";

export const urlBase64ToUint8Array = (base64String: string): Uint8Array => {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding)
    .replace(/\-/g, "+")
    .replace(/_/g, "/");

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
};

// Function to register the service worker
export const registerServiceWorker = async (
  swUrl: string
): Promise<ServiceWorkerRegistration> => {
  if (!("serviceWorker" in navigator)) {
    throw new Error("Service Workers are not supported in this browser.");
  }
  return navigator.serviceWorker.register(swUrl);
};

// Function to get or create a push subscription
export const getOrCreatePushSubscription = async (
  registration: ServiceWorkerRegistration,
  vapidPublicKey: string
): Promise<PushSubscription> => {
  if (!("PushManager" in window)) {
    throw new Error("PushManager is not supported in this browser.");
  }

  const existingSubscription = await registration.pushManager.getSubscription();
  if (existingSubscription) {
    console.log("Existing push subscription found.");
    return existingSubscription;
  }

  console.log("Creating new push subscription...");
  const applicationServerKey = urlBase64ToUint8Array(vapidPublicKey);
  // TS 5.9+: Pass ArrayBuffer to satisfy stricter DOM typings
  const newSubscription = await registration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: applicationServerKey.buffer as ArrayBuffer,
  });
  return newSubscription;
};

// Function to extract subscription details into your DTO
export const extractSubscriptionDetails = (
  subscription: PushSubscription
): WebPushRegistrationDto => {
  const key = subscription.getKey("p256dh");
  const auth = subscription.getKey("auth");

  if (!key || !auth) {
    throw new Error("Failed to get p256dh or auth keys from subscription.");
  }

  // Convert ArrayBuffer to Base64 string
  const p256DHBase64 = btoa(
    String.fromCharCode.apply(null, Array.from(new Uint8Array(key)))
  );
  const authBase64 = btoa(
    String.fromCharCode.apply(null, Array.from(new Uint8Array(auth)))
  );

  return {
    endpoint: subscription.endpoint,
    p256dH: p256DHBase64,
    auth: authBase64,
    userAgent: navigator.userAgent,
    deviceName:
      (navigator as any).userAgentData?.platform || navigator.platform,
  };
};
